var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "45px",
    viewBox: "0 0 60 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Welcome",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Details-Copy",
    transform: "translate(-933.000000, -388.000000)",
    fill: "#F99A01",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M987.375,395.5 L964.875,395.5 L958.710593,389.335593 C957.855427,388.480427 956.695573,388 955.486186,388 L938.625,388 C935.518359,388 933,390.518359 933,393.625 L933,427.375 C933,430.481641 935.518359,433 938.625,433 L987.375,433 C990.481641,433 993,430.481641 993,427.375 L993,401.125 C993,398.018359 990.481641,395.5 987.375,395.5 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.090295ff.svg";
export { ForwardRef as ReactComponent };